import e from "../managers/braze-instance.js";
import na from "./push-manager-factory.js";
export function unregisterPush(r, n) {
  if (e.X()) return na.m().unsubscribe(r, n);
}
